import getApi from '../../../api/apisauceConfig'
import { deserializeUserResponse } from './mapper/users.mapper'
import { SerializedUser } from './mapper/users.model'
import { ApiErrorContent } from '../../../model/Error'

export const getUser = (uuid: string, signal?: AbortSignal) =>
  getApi()
    .get<SerializedUser, ApiErrorContent>(`/admin/users/${uuid}`, {}, { signal })
    .then(deserializeUserResponse)
